module.exports = __webpack_public_path__ + "static/media/harina_aticaT.9e187e80.png";